var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.19 5.17516L7.29532 0.337493C7.18925 0.230553 7.06306 0.145673 6.92402 0.0877478C6.78499 0.0298229 6.63586 0 6.48524 0C6.33462 0 6.18549 0.0298229 6.04645 0.0877478C5.90741 0.145673 5.78122 0.230553 5.67516 0.337493L0.837494 5.17516C0.730553 5.28122 0.645672 5.40741 0.587747 5.54645C0.529822 5.68549 0.5 5.83462 0.5 5.98524C0.5 6.13586 0.529822 6.28499 0.587747 6.42402C0.645672 6.56306 0.730553 6.68925 0.837494 6.79532C1.05127 7.00782 1.34044 7.1271 1.64187 7.1271C1.94329 7.1271 2.23247 7.00782 2.44624 6.79532L6.48524 2.75632L10.5242 6.79532C10.7367 7.0061 11.0236 7.12493 11.3229 7.12619C11.4731 7.12706 11.6219 7.09828 11.7609 7.0415C11.8999 6.98472 12.0264 6.90106 12.133 6.79532C12.2437 6.69307 12.3331 6.56988 12.396 6.43288C12.4589 6.29588 12.494 6.14778 12.4993 5.99713C12.5046 5.84648 12.48 5.69628 12.4269 5.55519C12.3738 5.41411 12.2933 5.28494 12.19 5.17516Z",
    fill: "#F0F6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/arrow-top.3a80d9d1c3c56d506d6991ace0184d54.svg";
export { ForwardRef as ReactComponent };